<div class="ui-g-12">

    <div class="ui-g">
        <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
            <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [options]="indicator.options"></app-infobox>
        </div>
    </div>

    <div class="campaigncharts" *ngIf="data != null">
        <div class="ui-g">
            <div class="ui-g-12 ui-md-5 ui-sm-12">
                <h2>{{ translations.contactChannel }}</h2>
                <div class="chart-container">
                    <chart [options]="contactChannelChart.options"
                           (load)="setChartInstance(contactChannelChart, $event.context)"></chart>
                </div>
            </div>

            <div class="ui-g-12 ui-md-7 ui-sm-12">
                <h2>{{ translations.customersForChannel }}</h2>
                <div class="chart-container">
                    <chart [options]="customersForChannelChart.options"
                           (load)="setChartInstance(customersForChannelChart, $event.context)"></chart>
                </div>
            </div>
        </div>
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-contactable/contactable-channel/contactable-channel.component.html